import styled from 'styled-components';
import { ColouredImageMask } from '../../images/ColouredMask';
import src from './IconDropDown.background.svg';

export const IconDropDown = styled(ColouredImageMask).attrs({ src: String(src) })`
  height: 32px;
  width: 32px;
`;
